import {
    IonContent,
    IonItem,
    IonLabel,
    IonPage,
    IonText,
    IonCol,
    IonRow,
    IonFab,
    IonFabButton,
    IonIcon,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCheckbox,
    IonButton,
} from '@ionic/react';
import { getOr, map, size } from 'lodash/fp';
import { DateTime } from 'luxon';
import React from 'react';
import { useLeavesInfinite } from '../hooks/useSwr';
import { Leave } from '../types/models';
import { BottomSlotWarning } from '../App';
import { add, arrowForward } from 'ionicons/icons';
import { Header } from '../components/Header';
import { useHistory } from 'react-router';
import { dateFromOdoo } from '../utils/date';
import { LeaveState } from '../utils/odooUtils';
import { IosHeader } from '../components/IosHeader';

export enum ViewMode {
    Manual,
    Confirm,
    Adherent,
}

const MyLeave: React.FC = () => {
    const history = useHistory();
    const { standardizedOdooLeaves: leaves, size: leaveSize, setSize } = useLeavesInfinite();
    const title = 'Mes congés';

    return (
        <IonPage>
            <IosHeader title={title} />
            <IonContent>
                <Header title={title} />
                <IonFab slot="fixed" vertical="bottom" horizontal="end">
                    <IonFabButton routerLink="/mesconges/0">
                        <IonIcon icon={add}></IonIcon>
                    </IonFabButton>
                </IonFab>

                {/* Padding bottom pour pas que le IonFab chevauche les informations de la vue */}
                <div className="main-content-d pt-4 pb-14">
                    <div slot="content" className="content-validation-d left-offset-10 xl:flex xl:flex-wrap">
                        {map(
                            (leave) => (
                                <EmployeeLeaveItem
                                    key={leave.id}
                                    leave={leave}
                                    onclick={() => {
                                        history.push(`/mesconges/${leave.id}`);
                                    }}
                                />
                            ),
                            leaves
                        )}
                        {leaveSize * 10 <= leaves.length && (
                            <div className="ion-text-center madper-button w-full">
                                <IonButton
                                    shape="round"
                                    onClick={() => setSize(leaveSize + 1)}
                                    type="button"
                                    className="btn"
                                    expand="block"
                                >
                                    Voir plus
                                </IonButton>
                            </div>
                        )}
                        {size(leaves) === 0 && (
                            <IonItem className="ion-no-padding xl:w-full" lines="none">
                                <IonLabel className="text-center text-gray-500">Aucun congé</IonLabel>
                            </IonItem>
                        )}
                    </div>
                </div>
            </IonContent>
            <BottomSlotWarning />
        </IonPage>
    );
};

export const EmployeeLeaveItem: React.FC<{
    leave: Leave;
    checked?: boolean;
    nbChecked?: number;
    onSelectionFullCard?: boolean;
    onSelectionChange?: (leave: number[], selected: boolean) => void;
    onclick?: () => void;
    onValidate?: () => void;
}> = ({ leave, checked, nbChecked, onSelectionFullCard, onSelectionChange, onclick, onValidate }) => {
    // FIXME: This is a hack to avoid a bug where adhérent has access to leave data but not to the employee data (very weird), reproductible by logging in as an adhérent MZ4237C (demo-pointage-saisie.tetra-info.com)
    if (!leave.id) {
        return null;
    }

    const getTypeLabel = (type: string) => {
        const typeMapping: { [key: string]: { label: string } } = {
            paid_leave: { label: 'Congés payés' },
            rtt: { label: 'RTT' },
            unpaid_leave: { label: 'Congés sans solde' },
            other: { label: 'Autre' },
        };

        const typeInfo = typeMapping[type] || { label: 'Inconnu' };
        return <IonText>{typeInfo.label}</IonText>;
    };

    return (
        <>
            <IonCard
                key={leave.id}
                style={{ backgroundColor: 'white' }}
                className="xl:w-[calc(50%-20px)]"
                onClick={
                    onSelectionChange && onSelectionFullCard ? () => onSelectionChange([leave.id], !checked) : onclick
                }
            >
                <IonCardHeader style={{ backgroundColor: '#5e5e5e' }} className="ion-no-padding">
                    <IonRow className="ion-align-items-center">
                        {onSelectionChange && (
                            <IonCol size="1" className="text-center m-1.5">
                                <IonCheckbox
                                    labelPlacement="end"
                                    aria-label="Sélectionner"
                                    className="align-middle"
                                    name={`select-${leave.id}`}
                                    checked={checked}
                                    onClick={(e) => {
                                        onSelectionChange([leave.id], !checked);
                                    }}
                                    justify="start"
                                />
                            </IonCol>
                        )}
                        <IonCol className="text-center">
                            <IonText color="light" className="font-bold text-center">
                                Type
                            </IonText>
                            <br />
                            <IonText color="light">{getTypeLabel(leave.type)}</IonText>
                        </IonCol>
                        <IonCol size="1" className="rm-flex-size">
                            <div className="separator  text-center" style={{ fontSize: '20px' }}>
                                |
                            </div>
                        </IonCol>

                        <IonCol className="text-center">
                            <IonText color="light" className="font-bold text-center">
                                Soumis le
                            </IonText>
                            <br />
                            <IonText color="light">
                                {dateFromOdoo(leave.create_date).toLocaleString(DateTime.DATE_SHORT)}
                            </IonText>
                        </IonCol>

                        {onValidate && (
                            <>
                                <IonCol size="1" className="rm-flex-size">
                                    <div className="separator text-center" style={{ fontSize: '20px' }}>
                                        |
                                    </div>
                                </IonCol>
                                <IonCol className="text-center">
                                    <div className="w-full h-full p-1.5 madper-button no-margin">
                                        <IonButton
                                            disabled={nbChecked ? true : false}
                                            type="submit"
                                            expand="block"
                                            className="!w-full !h-full process-btn normal-case m-0"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onValidate();
                                            }}
                                        >
                                            Gérer
                                        </IonButton>
                                    </div>
                                </IonCol>
                            </>
                        )}
                    </IonRow>
                </IonCardHeader>
                <IonCardContent style={{ paddingTop: '20px' }}>
                    <ContentLeaveCard leave={leave} />
                </IonCardContent>
            </IonCard>
        </>
    );
};

export default MyLeave;

const Indicator: React.FC<{ state: LeaveState }> = ({ state }) => {
    const colorMatix = {
        [LeaveState.GeiqValidation]: '#32CD32',
        [LeaveState.AdherentValidation]: '#32CD32',
        [LeaveState.WaitValidation]: '#FFD700',
        [LeaveState.AdherentRefusal]: '#f06715',
        [LeaveState.GeiqRefusal]: '#f06715',
        [LeaveState.Canceled]: '#6d6d6d',
    };

    const indicatorStyle: React.CSSProperties = {
        backgroundColor: getOr('#FFD700', state, colorMatix),
        borderRadius: '50%',
        width: '10px',
        height: '10px',
        display: 'inline-block',
    };

    return <div style={indicatorStyle}></div>;
};

interface ColWithGreyBackgroundProps {
    label: string;
    text: string;
    size: string;
    extraLine: string;
}

const ColWithGreyBackground: React.FC<ColWithGreyBackgroundProps> = ({ label, text, size, extraLine }) => {
    return (
        <IonCol size={size} className="ion-text-center">
            <IonText>
                <div
                    style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginLeft: '-5px',
                        marginRight: '-5px',
                        padding: '0 5px',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 'calc(100% + 10px)',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            zIndex: -1,
                            borderRadius: '5px',
                        }}
                    />
                    <div style={{ position: 'relative', zIndex: 1 }}>{text}</div>
                </div>
            </IonText>

            <br />
            <IonText>{label}</IonText>
            {extraLine && (
                <>
                    <br />
                    <IonText>{extraLine}</IonText>
                </>
            )}
        </IonCol>
    );
};

const ContentLeaveCard: React.FC<{ leave: Leave }> = ({ leave }) => {
    const getStateLabel = (state: LeaveState) => {
        const stateMapping: { [key in LeaveState]: { label: string } } = {
            [LeaveState.WaitValidation]: { label: 'En attente' },
            [LeaveState.AdherentValidation]: { label: 'Validé adht.' },
            [LeaveState.AdherentRefusal]: { label: 'Refusé adht.' },
            [LeaveState.GeiqValidation]: { label: 'Validé GEIQ' },
            [LeaveState.GeiqRefusal]: { label: 'Refusé GEIQ' },
            [LeaveState.Canceled]: { label: 'Annulé' },
        };

        const stateInfo = stateMapping[state] || { label: 'Inconnu' };

        return <IonText>{stateInfo.label}</IonText>;
    };

    const labelHalfDay: any = {
        morning: 'Matin',
        afternoon: 'Après-midi',
    };

    // Valeur par défaut (leave.mode === "full_day")
    let end_text = 'Fin';
    let end_property = leave.date_end ? leave.date_end.toLocaleString(DateTime.DATE_SHORT) : '';
    let start_extra_line = '';
    let end_extra_line = '';

    if (leave.mode === 'half_day') {
        end_text = 'Demi-journée';
        end_property = labelHalfDay[leave.half_day];
    }

    if (leave.mode === 'advanced') {
        start_extra_line = labelHalfDay[leave.start_half_day];
        end_extra_line = labelHalfDay[leave.end_half_day];
    }
    return (
        <>
            <IonRow style={{ justifyContent: 'space-between' }} className="h-16">
                <ColWithGreyBackground
                    label="Début"
                    text={leave.date_start ? leave.date_start.toLocaleString(DateTime.DATE_SHORT) : ''}
                    size="4"
                    extraLine={start_extra_line}
                />
                {leave.mode !== 'half_day' && (
                    <IonCol size="1" className="ion-text-center">
                        <IonIcon icon={arrowForward} style={{ fontSize: '20px', fontWeight: 'bold' }} />
                    </IonCol>
                )}

                <ColWithGreyBackground label={end_text} text={end_property} size="4" extraLine={end_extra_line} />

                <IonCol size="3" className="ion-text-center">
                    <Indicator state={leave.state as LeaveState} />
                    <br />
                    <IonText>{getStateLabel(leave.state as LeaveState)}</IonText>
                </IonCol>
            </IonRow>
            {leave.employee_note && (
                <IonRow className="mt-1">
                    <IonCol size="12">
                        <IonLabel className="font-medium underline underline-offset-2">
                            Commentaire du salarié :{' '}
                        </IonLabel>
                        <br />
                        <IonLabel className="h-7 whitespace-pre-wrap">{leave.employee_note}</IonLabel>
                    </IonCol>
                </IonRow>
            )}
            {leave.adherent_note && (
                <IonRow className="mt-1">
                    <IonCol size="12">
                        <IonLabel className="font-medium underline underline-offset-2">
                            Commentaire de l'adhérent :{' '}
                        </IonLabel>
                        <br />
                        <IonLabel className="h-7 whitespace-pre-wrap">{leave.adherent_note}</IonLabel>
                    </IonCol>
                </IonRow>
            )}
            {leave.geiq_note && (
                <IonRow className="mt-1">
                    <IonCol size="12">
                        <IonLabel className="font-medium underline underline-offset-2">Commentaire du GEIQ : </IonLabel>
                        <br />
                        <IonLabel className="h-7 whitespace-pre-wrap">{leave.geiq_note}</IonLabel>
                    </IonCol>
                </IonRow>
            )}
        </>
    );
};
